import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { finectAPI } from '@finect/front-utils/finectAPI';
import { ACTIONS } from './actionTypes';
export function setError(error) {
  return {
    type: 'SET_ERROR',
    error: error
  };
}
export function setAuthorizationsACL(acl) {
  return {
    type: 'SET_ACL',
    acl: acl
  };
}
export function setAuthorizationsACLFetchingStatus(fetching, fetched) {
  return {
    type: 'SET_ACL_FETCHING_STATUS',
    fetching: fetching,
    fetched: fetched
  };
}
export function getAuthorizationsACL(cookie) {
  return function (dispatch) {
    return Promise.all([dispatch(setAuthorizationsACLFetchingStatus(true, true))]).then(function () {
      return finectAPI({
        version: 'v4',
        path: "users/me/authorizations/acl",
        credentials: cookie,
        method: 'GET',
        onSuccess: function onSuccess(_ref) {
          var data = _ref.data;
          return dispatch(setAuthorizationsACL(data));
        },
        onError: function onError() {
          return dispatch(setError({
            code: 404,
            message: 'Error al obtener getAuthorizationsACL'
          }));
        }
      });
    });
  };
}
export function setReceived(obtained) {
  return {
    type: ACTIONS.SET_RECEIVED,
    obtained: obtained
  };
}
export function setGranted(granted) {
  return {
    type: ACTIONS.SET_GRANTED,
    granted: granted
  };
}
export function setRequests(requestsSent) {
  return {
    type: ACTIONS.SET_REQUESTS,
    requestsSent: requestsSent
  };
}
export function setRequestsPending(requestsReceived) {
  return {
    type: ACTIONS.SET_REQUESTS_PENDING,
    requestsReceived: requestsReceived
  };
}
export function setRevokeGrantedAuthorization(authorization) {
  var scopes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return {
    type: ACTIONS.SET_REVOKE_GRANTED_AUTHORIZATION,
    authorization: authorization,
    scopes: scopes
  };
}
export function setPostAuthorizationStatus(userID, scopes) {
  return {
    type: ACTIONS.SET_POST_AUTHORIZATION_STATUS,
    userID: userID,
    scopes: scopes
  };
}
export function clearPostAuthorizationStatus() {
  return {
    type: ACTIONS.CLEAR_POST_AUTHORIZATION_STATUS
  };
}
export function setRevokingStatus(authorization, scopes) {
  return {
    type: ACTIONS.SET_REVOKING_STATUS,
    authorization: authorization,
    scopes: scopes
  };
}
export function clearRevokingStatus() {
  return {
    type: ACTIONS.CLEAR_REVOKING_STATUS
  };
}
export function setUpdatingRequestStatus(request, action) {
  return {
    type: ACTIONS.SET_UPDATING_REQUEST_STATUS,
    request: request,
    action: action
  };
}
export function clearUpdatingRequestStatus() {
  return {
    type: ACTIONS.CLEAR_UPDATING_REQUEST_STATUS
  };
}